<div class="timer" *ngIf="secondsToDday || minutesToDday || hoursToDday">
    <span id="days" *ngIf="daysToDday">{{daysToDday}}D(s) :</span>
    <span id="hours">{{hoursToDday}}H :</span>
    <span id="minutes">{{minutesToDday}}M :</span>
    <span id="seconds">{{secondsToDday}}S</span>
</div>
